
import { Component, Vue } from "vue-property-decorator";
import appConfig from "@/config/default/application";
import TermsZhTW from "./i18n/terms-zh-TW.vue";
import TermsEnUS from "./i18n/terms-en-US.vue";
import TermsJaJP from "./i18n/terms-ja-JP.vue";

@Component
export default class Terms extends Vue {
    get i18nComponent() {
        const lang = (this as any).$lang?.get?.() || "zh-TW";
        if (lang === "en-US") return TermsEnUS;
        if (lang === "ja-JP") return TermsJaJP;
        return TermsZhTW;
    }

    get supportEmail() {
        return appConfig.supportEmail;
    }

    get supportEmailHref() {
        return `mailto:${appConfig.supportEmail}?subject=QUAFF%20AI%20Terms`;
    }

    goBack() {
        this.$router.back();
    }

    printPage() {
        window.print();
    }
}
